export default (value: string | undefined): string => {
    if (typeof(value) === "string") {
        let result = value;

        if ((result.match(/\-/g) || []).length > 1) {
            result = result.replace(/\-([^*]+?)\-/g, "<br>$1</br>");
        }
        return result;
    }
    else {
        return "";
    }
};
